import { render, staticRenderFns } from "./goodsbase.vue?vue&type=template&id=5ec0f938&scoped=true&"
import script from "./goodsbase.vue?vue&type=script&lang=js&"
export * from "./goodsbase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec0f938",
  null
  
)

export default component.exports